import { render, staticRenderFns } from "./VerificationRecord.vue?vue&type=template&id=71f5ec31&scoped=true&"
import script from "./VerificationRecord.vue?vue&type=script&lang=js&"
export * from "./VerificationRecord.vue?vue&type=script&lang=js&"
import style0 from "./VerificationRecord.vue?vue&type=style&index=0&id=71f5ec31&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5ec31",
  null
  
)

export default component.exports